export const priceList = [
  {
    id: 'p-au9999',
    name: '黄金现货 AU9999',
    symbol: 'Au9999',
    type: 'spot',
    price: 562.30,
    change: 4.18,
    changePercent: 0.75,
    open: 558.40,
    high: 563.10,
    low: 557.62,
    prevClose: 558.12,
    volume: '18.6吨',
    unit: '元/克',
    market: '上海黄金交易所',
    updatedAt: '2026-10-12 15:30',
    trend: [556.2, 557.1, 558.0, 557.4, 559.2, 560.1, 559.5, 561.0, 560.4, 561.8, 562.0, 562.3],
  },
  {
    id: 'p-au9995',
    name: '黄金现货 AU9995',
    symbol: 'Au9995',
    type: 'spot',
    price: 561.05,
    change: 3.72,
    changePercent: 0.67,
    open: 557.60,
    high: 561.80,
    low: 556.90,
    prevClose: 557.33,
    volume: '6.2吨',
    unit: '元/克',
    market: '上海黄金交易所',
    updatedAt: '2026-10-12 15:30',
    trend: [556.0, 556.6, 557.2, 556.8, 558.1, 559.0, 558.6, 559.8, 560.2, 560.6, 560.9, 561.05],
  },
  {
    id: 'p-xauusd',
    name: '伦敦金现 XAU/USD',
    symbol: 'XAU/USD',
    type: 'spot',
    price: 2412.60,
    change: -8.45,
    changePercent: -0.35,
    open: 2421.30,
    high: 2426.80,
    low: 2408.40,
    prevClose: 2421.05,
    volume: '42.8万手',
    unit: '美元/盎司',
    market: '伦敦金银市场协会',
    updatedAt: '2026-10-12 15:28',
    trend: [2421, 2423, 2420, 2418, 2416, 2419, 2415, 2413, 2414, 2411, 2413, 2412.6],
  },
  {
    id: 'p-autd',
    name: '黄金延期 Au(T+D)',
    symbol: 'Au(T+D)',
    type: 'spot',
    price: 560.80,
    change: 3.95,
    changePercent: 0.71,
    open: 557.20,
    high: 561.60,
    low: 556.45,
    prevClose: 556.85,
    volume: '24.1万手',
    unit: '元/克',
    market: '上海黄金交易所',
    updatedAt: '2026-10-12 15:30',
    trend: [556.4, 557.0, 557.8, 557.2, 558.6, 559.4, 558.9, 560.0, 560.5, 560.9, 560.6, 560.8],
  },
  {
    id: 'p-shfe-main',
    name: '沪金主力 AU2412',
    symbol: 'AU2412',
    type: 'futures',
    price: 566.40,
    change: 5.12,
    changePercent: 0.91,
    open: 561.60,
    high: 567.30,
    low: 560.88,
    prevClose: 561.28,
    volume: '15.3万手',
    unit: '元/克',
    market: '上海期货交易所',
    updatedAt: '2026-10-12 15:00',
    trend: [561.0, 562.2, 563.1, 562.4, 564.0, 565.2, 564.6, 565.8, 566.1, 566.5, 566.2, 566.4],
  },
  {
    id: 'p-shfe-next',
    name: '沪金次主力 AU2506',
    symbol: 'AU2506',
    type: 'futures',
    price: 568.90,
    change: 4.66,
    changePercent: 0.83,
    open: 564.50,
    high: 569.60,
    low: 563.90,
    prevClose: 564.24,
    volume: '4.7万手',
    unit: '元/克',
    market: '上海期货交易所',
    updatedAt: '2026-10-12 15:00',
    trend: [564.0, 565.0, 565.8, 565.2, 566.6, 567.6, 567.0, 568.2, 568.6, 569.0, 568.7, 568.9],
  },
  {
    id: 'p-comex',
    name: 'COMEX 黄金期货 GC',
    symbol: 'GC',
    type: 'futures',
    price: 2438.20,
    change: -6.30,
    changePercent: -0.26,
    open: 2445.60,
    high: 2450.40,
    low: 2434.10,
    prevClose: 2444.50,
    volume: '28.9万手',
    unit: '美元/盎司',
    market: '纽约商品交易所',
    updatedAt: '2026-10-12 15:25',
    trend: [2445, 2447, 2443, 2441, 2439, 2442, 2438, 2436, 2437, 2435, 2436, 2438.2],
  },
  {
    id: 'p-london-fwd',
    name: '伦敦金远期合约',
    symbol: 'XAU-3M',
    type: 'futures',
    price: 2425.80,
    change: 2.10,
    changePercent: 0.09,
    open: 2423.60,
    high: 2428.40,
    low: 2421.20,
    prevClose: 2423.70,
    volume: '9.4万手',
    unit: '美元/盎司',
    market: '伦敦金银市场协会',
    updatedAt: '2026-10-12 15:26',
    trend: [2423.4, 2424.0, 2423.6, 2424.5, 2425.1, 2424.7, 2425.6, 2426.0, 2425.4, 2426.1, 2425.7, 2425.8],
  },
  {
    id: 'p-etf-518880',
    name: '黄金ETF基金 518880',
    symbol: '518880',
    type: 'spot',
    price: 5.62,
    change: 0.04,
    changePercent: 0.72,
    open: 5.58,
    high: 5.63,
    low: 5.57,
    prevClose: 5.58,
    volume: '3.8亿份',
    unit: '元/份',
    market: '上海证券交易所',
    updatedAt: '2026-10-12 15:00',
    trend: [5.58, 5.59, 5.58, 5.60, 5.61, 5.60, 5.61, 5.62, 5.61, 5.62, 5.62, 5.62],
  },
  {
    id: 'p-bar-100g',
    name: '投资金条 100g',
    symbol: 'BAR100',
    type: 'spot',
    price: 565.00,
    change: 4.00,
    changePercent: 0.71,
    open: 561.00,
    high: 565.50,
    low: 560.80,
    prevClose: 561.00,
    volume: '1.2吨',
    unit: '元/克',
    market: '上海黄金交易所',
    updatedAt: '2026-10-12 15:30',
    trend: [561.0, 561.8, 562.6, 562.0, 563.2, 564.0, 563.5, 564.4, 564.8, 565.1, 564.9, 565.0],
  },
];